
<template>
    
        <mars-view class="fixed-btn-box"><mars-view class="submit-btn" :style="{
            backgroundColor: btnInfo.button_color || '#0054fd',
            color: btnInfo.content_color || '#fff',
        }" @click.native="onBtnClick"><div class="submit-title">
            {{ btnInfo.content || '0元咨询' }}
        </div></mars-view><clue-popup :info="info" :show="isShowCluePop" :form-info="formInfo" :query-info="queryInfo" :com-type="comType" :optype="optype" @formChange="formChange" @successSubmit="successSubmit" @close="onClose"></clue-popup></mars-view>
    
</template>

<script>
import cluePopup from "./cluePopup.vue";
import log from '../../../static/utils/ubcLog';
export default {
  components: {
    'clue-popup': cluePopup
  },
  props: {
    info: {
      type: Array,
      default: () => []
    },
    formInfo: {
      type: Object,
      default: () => {}
    },
    btnInfo: {
      type: Object,
      default: () => {}
    },
    // url信息
    queryInfo: {
      type: Object,
      default: () => {}
    },
    // 组件类型
    comType: {
      type: String,
      default: ''
    },
    optype: {
      type: String,
      default: ''
    }
  },
  watch: {
    isShowCluePop(val) {
      this.$emit('showPop', val);
    }
  },
  data() {
    return {
      isShowCluePop: false
    };
  },
  mounted() {
    log.send({
      area: 'activityModule',
      part: this.comType,
      serverId: 17510,
      action: 'show',
      optype: this.optype
    });
    log.send({
      area: 'pref_guide',
      serverId: 17260,
      action: 'show',
      optype: this.optype
    });
  },
  methods: {
    /**
     * 按钮点击
     */

    onBtnClick() {
      this.isShowCluePop = true;
    },
    /**
     * 关闭弹窗
     */

    onClose() {
      this.isShowCluePop = false;
    },
    /**
     * 表单切换
     */

    formChange(info) {
      this.$emit('formChange', info);
    },
    /**
     * 表单提交成功
     */
    successSubmit() {
      this.$emit('successSubmit');
    }
  }
};
</script>

<style scoped>
.fixed-btn-box {
  position: fixed;
  width: 100%;
  height: 13.53vw;
  display: flex;
  justify-content: center;
  border-top: 0.24vw solid #f5f6f9;
  bottom: 0;
  left: 0;
  z-index: 9;
  background-color: #fff;
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
}
.fixed-btn-box .submit-btn {
  flex: 1;
  margin: 1.93vw 4.51vw 0;
  position: relative;
  height: 9.66vw;
  text-align: center;
  color: #fff;
  font-family: "PingFang SC";
  font-size: 3.62vw;
  font-style: normal;
  font-weight: 500;
  line-height: 9.66vw;
  border-radius: 0.22rem;
  background: #0054fd;
}
.fixed-btn-box .submit-btn .submit-title {
  font-family: "PingFang SC";
  font-size: 3.62vw;
  font-style: normal;
  font-weight: 500;
}
.fixed-btn-box .submit-btn.disabled {
  background: rgba(0, 84, 253, 0.1);
}

</style>
